import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Row } from 'seagull';
import { PromptInputField } from '~/components/ai/PromptInputField/PromptInputField';
import { useStoreActions } from '~/store/store-context';
import { HelpMeWriteTextFieldTestIds, presetButtonTestId } from './HelpMeWriteTextField.types';
import PresetButton from './PresetButton';
const HelpMeWriteTextField = (param)=>{
    let { value, onChange, onSubmit, onPresetClick, isLoading = false, disabled = false, conversationId = '', isUndoLoading = false, presets, suggestions, placeholder, biEventIds } = param;
    const { logBI } = useStoreActions();
    const isDisabled = disabled || isLoading || isUndoLoading;
    const textFieldRef = useRef(null);
    const handlePresetClick = (presetValue)=>{
        const eventId = biEventIds.presetClick[presetValue];
        if (eventId != null) {
            logBI(eventId);
        }
        onPresetClick(presetValue);
    };
    const handleSubmit = ()=>{
        if (value === null || value === void 0 ? void 0 : value.trim()) {
            logBI(biEventIds.submitPrompt, {
                text: value.trim()
            });
        }
        onChange('');
        onSubmit();
    };
    const animatedSuggestions = conversationId ? [] : suggestions;
    useEffect(()=>{
        if (!isDisabled && textFieldRef.current) {
            const timeoutId = setTimeout(()=>{
                var _textFieldRef_current;
                const textarea = (_textFieldRef_current = textFieldRef.current) === null || _textFieldRef_current === void 0 ? void 0 : _textFieldRef_current.querySelector('textarea');
                if (textarea) {
                    textarea.focus();
                }
            }, 300);
            return ()=>clearTimeout(timeoutId);
        }
    }, [
        isDisabled
    ]);
    return /*#__PURE__*/ _jsx(PromptInputField, {
        testId: HelpMeWriteTextFieldTestIds.Root(),
        value: value,
        onChange: onChange,
        onSubmit: handleSubmit,
        disabled: isDisabled,
        submitDisabled: isDisabled,
        suggestions: [
            ...animatedSuggestions
        ],
        placeholder: placeholder,
        inputContainerRef: textFieldRef,
        leftActions: /*#__PURE__*/ _jsx(Row, {
            gap: 8,
            children: presets.map((preset)=>/*#__PURE__*/ _jsx(PresetButton, {
                    onClick: ()=>handlePresetClick(preset.value),
                    disabled: isDisabled,
                    testId: presetButtonTestId(preset.value),
                    label: preset.label,
                    biName: preset.biName
                }, preset.value))
        })
    });
};
export default HelpMeWriteTextField;
